import { render, staticRenderFns } from "./InquiryList.vue?vue&type=template&id=ae913362&scoped=true"
import script from "./InquiryList.vue?vue&type=script&lang=js"
export * from "./InquiryList.vue?vue&type=script&lang=js"
import style0 from "./InquiryList.vue?vue&type=style&index=0&id=ae913362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae913362",
  null
  
)

export default component.exports